<template>
  <v-card :loading="form_loading" flat elevation="0">
    <v-form @submit.prevent="submit()">
      <input
        @input="changeAvatar($event)"
        type="file"
        name
        id
        ref="avatar"
        v-show="false"
        accept="image/*"
      />

      <v-toolbar color="primary" dark>
        <v-toolbar-title>
          <v-btn v-if="showReturn" @click="$router.go(-1)" icon exact>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          Cliente
        </v-toolbar-title>

        <v-spacer />
        <v-btn icon @click="close()" v-if="closable">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <template v-slot:extension>
          <v-tabs v-model="tab">
            <v-tabs-slider></v-tabs-slider>

            <v-tab>Dados</v-tab>
            <v-tab v-if="form.id">Endereços</v-tab>
            <v-tab v-if="form.id">Ficha</v-tab>
            <v-tab v-if="form.id">Locações</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <ValidationObserver ref="form" v-slot="{ invalid }">
            <v-card-text class="mt-5">
              <v-row dense>
                <v-col class="text-right">
                  <v-menu bottom offset-y close-on-click>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        color="grey"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        elevation="0"
                      >
                        Opções
                      </v-btn>
                    </template>

                    <v-list>
                      <v-item-group>
                        <v-list-item v-if="form.image" @click="removeAvatar()">
                          <v-list-item-title class="red--text">
                            Remover foto
                          </v-list-item-title>
                        </v-list-item>
                      </v-item-group>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="text-center">
                  <v-avatar size="160" color="grey lighten-1" rounded>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                      v-if="!form.image_url && !form_loading"
                    >
                      <v-icon :size="70" color="#f1f1f1">
                        mdi-image-off-outline
                      </v-icon>
                    </v-row>
                    <v-img
                      v-else
                      :src="form.image_url"
                      @error="image_error = true"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-icon :size="70" color="#f1f1f1" v-if="image_error">
                            mdi-image-off-outline
                          </v-icon>
                          <v-progress-circular
                            indeterminate
                            color="white"
                            size="50"
                            v-else
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <v-btn
                    @click="openImageGetter()"
                    fab
                    color="primary"
                    :loading="image_loading"
                    :disabled="form_loading"
                  >
                    <v-icon> mdi-camera</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col v-if="form.id" cols="3" sm="2">
                  <v-text-field
                    label="Código"
                    :value="form.id"
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col>
                  <ValidationProvider
                    name="nome"
                    rules="required|max:100"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :value="form.nome"
                      @input="updateValue('nome', $event)"
                      label="Nome"
                      name="nome"
                      :error-messages="errors"
                      :disabled="form_loading"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>
              <ValidationProvider
                name="tipo"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :value="form.tipo"
                  :items="[
                    { value: 'F', text: 'Física' },
                    { value: 'J', text: 'Jurídica' }
                  ]"
                  @input="updateValue('tipo', $event)"
                  label="Tipo"
                  name="tipo"
                  :error-messages="errors"
                  :disabled="form_loading"
                />
              </ValidationProvider>
              <v-row>
                <v-col>
                  <ValidationProvider
                    name="contato1"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :value="form.contato1"
                      @input="updateValue('contato1', $event)"
                      label="Telefone 1"
                      :disabled="form_loading"
                      v-mask="'(##) ?#####-####'"
                      name="contato1"
                      type="tel"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>
                <v-col>
                  <v-text-field
                    :value="form.contato2"
                    @input="updateValue('contato2', $event)"
                    label="Telefone 2"
                    :disabled="form_loading"
                    v-mask="'(##) ?#####-####'"
                    name="contato2"
                    type="tel"
                    hint="Opcional"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <ValidationProvider
                    name="documento_fiscal"
                    :rules="{
                      numeric: true,
                      documento_fiscal: true
                    }"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      :value="form.documento_fiscal"
                      @input="updateValue('documento_fiscal', $event)"
                      label="CPF/CNPJ"
                      :disabled="form_loading"
                      hint="Somente números / Opcional"
                      name="documento_fiscal"
                      :error-messages="errors"
                      maxlength="14"
                    />
                  </ValidationProvider>
                </v-col>
                <v-col>
                  <ValidationProvider name="rg" rules="" v-slot="{ errors }">
                    <v-text-field
                      :value="form.rg"
                      @input="updateValue('rg', $event)"
                      label="RG/IE"
                      :disabled="form_loading"
                      hint="Opcional"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>
              </v-row>

              <ValidationProvider
                name="email"
                rules="email"
                v-slot="{ errors }"
              >
                <v-text-field
                  :value="form.email"
                  @input="updateValue('email', $event)"
                  label="Email"
                  :error-messages="errors"
                  :disabled="form_loading"
                  hint="Opcional"
                />
              </ValidationProvider>

              <v-row>
                <v-col>
                  <money-input
                    v-model="limite_credito_total"
                    name="preco_venda"
                    :options="money_options"
                    label="Crédito aprovado"
                    :disabled="form_loading"
                  />
                </v-col>
              </v-row>

              <v-textarea
                :value="form.observacoes"
                @input="updateValue('observacoes', $event)"
                label="Observações"
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                color="primary"
                :loading="submitting"
                :disabled="invalid"
              >
                Salvar
              </v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col></v-col>
                <v-col class="d-flex align-center justify-end">
                  <v-btn
                    color="primary"
                    outlined
                    @click="createNewEndereco"
                    :disabled="form_loading"
                  >
                    Novo endereço
                  </v-btn>
                </v-col>
              </v-row>

              <v-divider></v-divider>
              <ClientAddressesList
                @click="editEndereco"
                @click:delete="confirmDeleteAddress"
                :items="form.enderecos"
              />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <ClientCreditTransactionsTab :client_id="form.id" />
        </v-tab-item>
        <v-tab-item>
          <ClienteLocacoesTab :clienteId="form.id" />
        </v-tab-item>
      </v-tabs-items>
    </v-form>
    <v-dialog v-model="address_dialog" width="500px" persistent>
      <v-card :disabled="saving_address" :loading="saving_address">
        <v-app-bar flat>
          <v-toolbar-title>Endereço</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="closeAddressDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-form @submit.prevent="applyAddress">
          <ValidationObserver ref="endereco_form">
            <v-card flat class="pa-4">
              <v-card-text>
                <ValidationProvider name="cep" v-slot="{ errors }">
                  <v-text-field
                    v-model="endereco.cep"
                    label="CEP"
                    v-mask="'#####-###'"
                    :error-messages="errors"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="estado"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-autocomplete
                    v-model="endereco.uf"
                    label="Estado"
                    :items="estados_brasil"
                    item-text="sigla"
                    item-value="sigla"
                    @change="getCidades"
                    :return-object="false"
                    :error-messages="errors"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="cidade"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-combobox
                    v-model="endereco.cidade"
                    label="Cidade"
                    item-text="nome"
                    item-value="nome"
                    :loading="loading_cidades"
                    :items="cidades"
                    :error-messages="errors"
                    :return-object="false"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="rua"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="endereco.rua"
                    label="Rua"
                    :error-messages="errors"
                    autofocus
                  />
                </ValidationProvider>
                <v-text-field v-model="endereco.numero" label="Número" />
                <ValidationProvider
                  name="bairro"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="endereco.bairro"
                    label="Bairro"
                    :error-messages="errors"
                  />
                </ValidationProvider>
                <v-text-field
                  v-model="endereco.complemento"
                  label="Complemento"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn type="submit" color="primary">Aplicar</v-btn>
              </v-card-actions>
            </v-card>
          </ValidationObserver>
        </v-form>
      </v-card>
    </v-dialog>
    <confirm-action-dialog
      :confirm_action="confirm_address_delete"
      @change="confirm_address_delete = $event"
      @action="deleteAddress"
      message="O endereço será permanentemente excluído"
    ></confirm-action-dialog>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { deleteClientAddress } from "@/services/clients";
import { listEstados, listDistritos } from "@/services/locals";
import ConfirmActionDialog from "@/components/ConfirmActionDialog";
import MoneyInput from "@/components/MoneyInput";
import MoneyMixin from "@/mixins/MoneyMixin";
import ClientCreditTransactionsTab from "@/components/ClientCreditTransactionsTab";
import ClientAddressesList from "@/components/ClientAddressesList";
import ClienteLocacoesTab from "../ClienteLocacoesTab.vue";
import {
  update as updateAddress,
  create as storeAddress,
  index as indexAddresses
} from "@/services/client_addresses";

export default {
  name: "client-form",
  mixins: [MoneyMixin],
  components: {
    ConfirmActionDialog,
    MoneyInput,
    ClientCreditTransactionsTab,
    ClientAddressesList,
    ClienteLocacoesTab
  },
  props: {
    visible: Boolean,
    closable: {
      type: Boolean,
      default: true
    },
    showReturn: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    tab: 0,
    endereco: {},
    address_dialog: false,
    confirm_address_delete: false,
    address_delete: null,
    cidades: [],
    loading_cidades: false,
    saving_address: false,
    config: {
      mask: "###",
      masked: false
    },
    image_error: false,
    image_loading: false,
    limites_credito: [
      {
        text: "R$ 0,00",
        value: 0
      },
      {
        text: "R$ 200,00",
        value: 200.0
      },
      {
        text: "R$ 400,00",
        value: 400
      },
      {
        text: "R$ 600,00",
        value: 600
      },
      {
        text: "R$ 800,00",
        value: 800
      },
      {
        text: "R$ 1.000,00",
        value: 1000.0
      },
      {
        text: "R$ 2.000,00",
        value: 2000
      },
      {
        text: "R$ 5.000,00",
        value: 5000
      },
      {
        text: "R$ 10.000,00",
        value: 10000
      }
    ]
  }),
  methods: {
    ...mapActions("clients", [
      "indexClients",
      "deleteClient",
      "showClient",
      "updateClient",
      "createClient",
      "destroyAddress"
    ]),
    ...mapMutations("clients", [
      "setForm",
      "cleanForm",
      "editAddress",
      "setImageChanged"
    ]),
    close(success = false) {
      if (success) {
        this.$emit("submitted");
      } else {
        this.$emit("cancel");
      }
      this.tab = 0;
      this.cleanForm();
      this.$refs.form.reset();
    },
    reset() {
      this.tab = 0;
      this.cleanForm();
      this.$refs.form.reset();
    },
    openImageGetter() {
      this.$refs.avatar.click();
    },
    async changeAvatar(event) {
      if (!event.target.files[0]) {
        return;
      }

      this.updateValue("image_url", this.getUrlPreview(event.target.files[0]));
      this.updateValue("image", event.target.files[0]);
      this.photo_changed = true;

      this.$refs.avatar.value = null;

      await this.$nextTick();
    },
    async removeAvatar() {
      // await this.$http.post(`/clients/${this.form.id}/remover_imagem`);
      if (this.form.image) {
        this.photo_changed = true;
      }

      this.updateValue("image_url", null);
      this.updateValue("image", null);
    },
    getUrlPreview(image) {
      return URL.createObjectURL(image);
    },
    async destroyPhoto() {
      this.image_loading = true;
      try {
        await this.$http.post(`/clients/${this.form.id}/remover_imagem`);
      } catch (error) {
        this.$store.commit("error", error);
      } finally {
        this.image_loading = false;
      }
    },
    async updatePhoto() {
      this.image_loading = true;
      let data = new FormData();
      data.append("image", this.form.image);

      try {
        await this.$http.post(`/clients/${this.form.id}/alterar_imagem`, data);
      } catch (error) {
        this.$store.commit("error", error);
      } finally {
        this.image_loading = false;
      }
    },
    async submit() {
      const validation = await this.$refs.form.validate();
      if (!validation) return;
      try {
        if (this.form.id) {
          await this.updateClient();
        } else {
          await this.createClient();
        }

        if (this.photo_changed) {
          if (!!this.form.image_url) {
            await this.updatePhoto();
          } else {
            await this.destroyPhoto();
          }
        }

        this.$emit("submitted");
      } catch (error) {
        if (error.response) {
          switch (error.response.status) {
            case 422:
              this.$refs.form.setErrors(error.response.data.errors);
              break;
            case 500:
              this.$store.commit("error", "500: Falha ao salvar cliente.");
              break;
            default:
              this.$store.commit("error", error);
          }
        } else {
          console.error(error);
          this.$store.commit("error", error);
        }
      }
    },
    updateValue(key, value) {
      this.setForm({
        ...this.form,
        [key]: value
      });
    },
    getRGIEMask() {
      if (!this.form.tipo) return "";
      return this.form.tipo.value == "F" ? "##.###.###-N" : "";
    },
    createNewEndereco() {
      this.resetEnderecoForm();
      this.address_dialog = true;
    },
    resetEnderecoForm() {
      this.endereco = {
        cep: "13700-000",
        uf: "SP",
        cidade: "Casa Branca"
      };
      if (this.$refs.endereco_form) {
        this.$refs.endereco_form.reset();
      }
    },
    editEndereco(address) {
      this.address_dialog = true;
      this.endereco = {
        ...address
      };
    },
    async closeAddressDialog() {
      this.address_dialog = false;
    },
    async getAdresses() {
      this.form.enderecos = [];
      const response = await indexAddresses(this.form.id);
      this.form.enderecos = response.data;
    },
    async applyAddress() {
      const validation = await this.$refs.endereco_form.validate();
      if (!validation) return;

      this.saving_address = true;
      try {
        if (this.endereco.id) {
          await updateAddress(this.form.id, this.endereco.id, this.endereco);
        } else {
          await storeAddress(this.form.id, this.endereco);
        }
        this.closeAddressDialog();
        this.getAdresses();
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Não foi possível salvar o endereço",
          color: "red"
        });
      } finally {
        this.saving_address = false;
      }
    },
    confirmDeleteAddress(address) {
      this.confirm_address_delete = true;
      this.address_delete = {
        ...address
      };
    },
    async deleteAddress() {
      if (this.address_delete.id != null) {
        try {
          await deleteClientAddress(this.form.id, this.address_delete.id);
          this.updateValue(
            "enderecos",
            this.form.enderecos.filter(rec => rec.id != this.address_delete.id)
          );
        } catch (e) {
          this.$store.commit("sendMessage", {
            text: "Não foi possível excluir este endereço",
            color: "red"
          });
        } finally {
          this.confirm_address_delete = false;
          this.address_delete = null;
        }
      } else {
        const enderecos = this.form.enderecos;
        enderecos.splice(this.address_delete.index, 1);
        this.updateValue("enderecos", enderecos);
        this.confirm_address_delete = false;
        this.address_delete = null;
      }
    },
    async getCidades(estado) {
      this.loading_cidades = true;
      if (estado) {
        this.cidades = [];
        this.endereco.cidade = null;
        try {
          const response = await listDistritos(estado);
          this.cidades = response;
        } catch (e) {
          this.cidades = [];
        } finally {
          this.loading_cidades = false;
        }
      } else {
        this.cidades = [];
      }
    }
  },
  computed: {
    contato1_mask: function() {
      // if (!this.form.contato1) return "(##) #####-####";
      if (!this.form.contato1) return "(##) #####-####";
      return this.form.contato1.length < 15
        ? "(##) ####-####"
        : "(##) #####-####";
    },
    contato2_mask: function() {
      // if (!this.form.contato2) return "(##) #####-####";
      if (!this.form.contato2) return "(##) #####-####";
      return this.form.contato2.length < 15
        ? "(##) ####-####"
        : "(##) #####-####";
    },
    estados_brasil: function() {
      return listEstados();
    },
    user() {
      return this.$store.getters.getUser;
    },
    limite_credito_total: {
      get() {
        return parseFloat(this.form.limite_credito_total);
      },
      set(value) {
        this.updateValue("limite_credito_total", value);
      }
    },
    photo_changed: {
      get() {
        return this.$store.getters["clients/getImageChanged"];
      },
      set(value) {
        this.setImageChanged(value);
      }
    },
    ...mapState("clients", ["form", "form_loading", "submitting"])
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.setForm();
        this.$refs.form.reset();
        this.image_error = false;
      }
    }
  }
};
</script>
